import DomainObjectForm from 'app/shared-components/DomainObjectForm'
import {
    ChangeRequestApprovalType, Order,
} from 'app/Apps/OrderManagement/Orders/orders.types'
import {
    DeliveryServiceType,
} from 'app/enums/label.enums'

import getFields from './requiredContainers.fields'

const RequiredContainers = ({
    value,
    setValue,
}: {
    value: Order & ChangeRequestApprovalType,
    setValue: (newVal: Order & ChangeRequestApprovalType) => void,
}) => {
    const isDeliveryRoad: boolean = value?.deliveryServiceType === DeliveryServiceType.DELIVERY_ROAD
    const fields = getFields(value, isDeliveryRoad)

    return (
        <DomainObjectForm
            value={value}
            onChange={setValue}
            fields={fields}
            name="RequiredContainers"
        />
    )
}

export default RequiredContainers
